import CustomLink from '@/bit/components/components.custom-link';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';

function SimpleHeader({ cyData }) {
  return (
    <header className="SimpleHeader__link">
        <div className="container">
        <CustomLink
        className=""
        href="https://www.movistar.es"
        title="Logo Movistar"
        ariaLabel="ir a home"
        taggingInfo={{
            componentName: 'link',
            componentContent: 'LogoM',
            componentVariation: 'all',
            componentPerso: '',
            componentProduct: '',
        }}
        cyData={`${cyData}__link`}
        >
        <IconGlyph
            className="movistar-m--size-s"
            id="movistar"
            kind="m"
            width={38}
            color={COLOR_DICTIONARY.MOVISTAR_BLUE}
            priority
        />
        <IconGlyph
            className="movistar-m--size-m"
            id="movistar-logo-h-m"
            alt="Movistar-icono"
            height={26.73}
            width={112}
            color={COLOR_DICTIONARY.MOVISTAR_BLUE}
            priority
        />
        <IconGlyph
            className="movistar-m--size-l"
            id="movistar-logo-h-m"
            alt="Movistar-icono"
            height={32}
            width={134}
            color={COLOR_DICTIONARY.MOVISTAR_BLUE}
            priority
        />
        </CustomLink>
        </div>
    <style jsx>
        {`
          .SimpleHeader__link {
            padding: 8px 0px 16px 0px;
            :global(.movistar-m--size-s) {
                display: inline-block !important;
            }
            :global(.movistar-m--size-m) {
                display: none !important;
            }
            :global(.movistar-m--size-l) {
                display: none !important;
            }
            @media screen and (min-width: 1024px) {
                :global(.movistar-m--size-s) {
                display: none !important;
                }
                :global(.movistar-m--size-m) {
                display: inline-block !important;
                }
                :global(.movistar-m--size-l) {
                display: none !important;
                }
            }
            @media screen and (min-width: 1280px) {
                :global(.movistar-m--size-s) {
                display: none !important;
                }
                :global(.movistar-m--size-m) {
                display: none !important;
                }
                :global(.movistar-m--size-l) {
                display: inline-block !important;
                }
            }
          }
        `}
      </style>
    </header>
  );
}
export default SimpleHeader;
